import { render, staticRenderFns } from "./WtUploadImage.vue?vue&type=template&id=510d91d6&lang=pug&"
import script from "./WtUploadImage.vue?vue&type=script&lang=js&"
export * from "./WtUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./WtUploadImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports